import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { CustomSelectWithoutSearch, } from './CustomSelectWithoutSearch';
import { CustomSelectWithSearch } from './CustomSelectWithSearch';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isCustomSelectWithSearchProps(props) {
    return !!props?.onInputChange;
}
export const CustomSelect = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
(props, ref) => {
    const customSelectRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focus: () => {
            customSelectRef.current?.focus();
        },
    }));
    if (isCustomSelectWithSearchProps(props)) {
        return _jsx(CustomSelectWithSearch, { ref: customSelectRef, ...props });
    }
    return _jsx(CustomSelectWithoutSearch, { ref: customSelectRef, ...props });
});
//# sourceMappingURL=CustomSelect.js.map